(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash-es"), require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash-es", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["videojs-utils"] = factory(require("lodash-es"), require("jquery"));
	else
		root["videojs-utils"] = factory(root["_"], root["$"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__87a6__, __WEBPACK_EXTERNAL_MODULE_c5e1__) {
return 